import { PreferredLanguage } from '@shared/generated/models/PreferredLanguage';
import announcements from '@shared/locales/en/announcements.json';
import applyForIncomeVerification from '@shared/locales/en/applyForIncomeVerification.json';
import combustionSafetyTesting from '@shared/locales/en/combustionSafetyTesting.json';
import commonActions from '@shared/locales/en/commonActions.json';
import commonAttachments from '@shared/locales/en/commonAttachments.json';
import commonEquipment from '@shared/locales/en/commonEquipment.json';
import commonFormValidation from '@shared/locales/en/commonFormValidation.json';
import commonJob from '@shared/locales/en/commonJob.json';
import commonLabels from '@shared/locales/en/commonLabels.json';
import commonMessages from '@shared/locales/en/commonMessages.json';
import commonPrograms from '@shared/locales/en/commonPrograms.json';
import commonSignDocument from '@shared/locales/en/commonSignDocument.json';
import commonTasks from '@shared/locales/en/commonTasks.json';
import commonUser from '@shared/locales/en/commonUser.json';
import companyProfile from '@shared/locales/en/companyProfile.json';
import confirmDecommissioningChecklistData from '@shared/locales/en/confirmDecommissioningChecklistData.json';
import confirmInstallDates from '@shared/locales/en/confirmInstallDates.json';
import confirmInstalledHeatPump from '@shared/locales/en/confirmInstalledHeatPump.json';
import confirmInstalledWaterHeater from '@shared/locales/en/confirmInstalledWaterHeater.json';
import confirmPostInstallDetails from '@shared/locales/en/confirmPostInstallDetails.json';
import confirmPostInstallDetailsClothesDryer from '@shared/locales/en/confirmPostInstallDetailsClothesDryer.json';
import confirmPostInstallDetailsInduction from '@shared/locales/en/confirmPostInstallDetailsInduction.json';
import confirmPostInstallEccCaTechSfv from '@shared/locales/en/confirmPostInstallEccCaTechSfv.json';
import confirmPostInstallDetailsEvaporativeCooler from '@shared/locales/en/confirmPostInstallDetailsEvaporativeCooler.json';
import confirmPostInstallDetailsHeatPump from '@shared/locales/en/confirmPostInstallDetailsHeatPump.json';
import confirmPostInstallDetailsHeating from '@shared/locales/en/confirmPostInstallDetailsHeating.json';
import confirmPostInstallDetailsLoadManagement from '@shared/locales/en/confirmPostInstallDetailsLoadManagement.json';
import confirmPostInstallDetailsVentilation from '@shared/locales/en/confirmPostInstallDetailsVentilation.json';
import confirmPostInstallDetailsWaterHeater from '@shared/locales/en/confirmPostInstallDetailsWaterHeater.json';
import confirmPostInstallPhotosElectrical from '@shared/locales/en/confirmPostInstallPhotosElectrical.json';
import confirmPostInstallPhotosGasFurnace from '@shared/locales/en/confirmPostInstallPhotosGasFurnace.json';
import confirmPostInstallPhotosHeatPump from '@shared/locales/en/confirmPostInstallPhotosHeatPump.json';
import confirmPostInstallPhotosVentilation from '@shared/locales/en/confirmPostInstallPhotosVentilation.json';
import confirmPostInstallPhotosWaterHeater from '@shared/locales/en/confirmPostInstallPhotosWaterHeater.json';
import confirmPreInstallDetails from '@shared/locales/en/confirmPreInstallDetails.json';
import confirmProjectFinalCosts from '@shared/locales/en/confirmProjectFinalCosts.json';
import constraint from '@shared/locales/en/constraint.json';
import contractor from '@shared/locales/en/contractor.json';
import createInitialInvoice from '@shared/locales/en/createInitialInvoice.json';
import createOfferLetterDocument from '@shared/locales/en/createOfferLetterDocument.json';
import createScopeOfWork from '@shared/locales/en/createScopeOfWork.json';
import decommissioningChecklistData from '@shared/locales/en/decommissioningChecklistData.json';
import decommissioningChecklistDataCollection from '@shared/locales/en/decommissioningChecklistDataCollection.json';
import defineScopeOfWork from '@shared/locales/en/defineScopeOfWork.json';
import determineShareRebateAmount from '@shared/locales/en/determineShareRebateAmount.json';
import downloadApplicationLadwp from '@shared/locales/en/downloadApplicationLadwp.json';
import eligibility from '@shared/locales/en/eligibility.json';
import energyProviders from '@shared/locales/en/energyProviders.json';
import enrollInRequiredInitiatives from '@shared/locales/en/enrollInRequiredInitiatives.json';
import envelopePart from '@shared/locales/en/envelopePart.json';
import error from '@shared/locales/en/error.json';
import existingElectricalSystem from '@shared/locales/en/existingElectricalSystem.json';
import existingWeatherizationDetails from '@shared/locales/en/existingWeatherizationDetails.json';
import hvacSystem from '@shared/locales/en/hvacSystem.json';
import incentive from '@shared/locales/en/incentive.json';
import initiateIncomeQualificaiton from '@shared/locales/en/initiateIncomeQualification.json';
import jobCreate from '@shared/locales/en/jobCreate.json';
import jobDetails from '@shared/locales/en/jobDetails.json';
import jobsList from '@shared/locales/en/jobsList.json';
import login from '@shared/locales/en/login.json';
import mechanicalVentilation from '@shared/locales/en/mechanicalVentilation.json';
import opportunityAttemptContact from '@shared/locales/en/opportunityAttemptContact.json';
import opportunityFirstContact from '@shared/locales/en/opportunityFirstContact.json';
import opportunityScheduleAppointment from '@shared/locales/en/opportunityScheduleAppointment.json';
import opportunityVisitHome from '@shared/locales/en/opportunityVisitHome.json';
import optionalPreApprovalReservationNyCleanHeatConEd from '@shared/locales/en/optionalPreApprovalReservationNyCleanHeatConEd.json';
import postCASTesting from '@shared/locales/en/postCASTesting.json';
import preCASTesting from '@shared/locales/en/preCASTesting.json';
import preHomeSafetyAssessment from '@shared/locales/en/preHomeSafetyAssessment.json';
import preLimitedHVACAssessment from '@shared/locales/en/preLimitedHVACAssessment.json';
import programPolicies from '@shared/locales/en/programPolicies.json';
import programSelection from '@shared/locales/en/programSelection.json';
import programSubmissionsHistory from '@shared/locales/en/programSubmissionsHistory.json';
import proposedElectricalSystem from '@shared/locales/en/proposedElectricalSystem.json';
import proposedWeatherizationDetails from '@shared/locales/en/proposedWeatherizationDetails.json';
import provideAdditionalIncentivesDetails from '@shared/locales/en/provideAdditionalIncentivesDetails.json';
import provideCommissioningFormDetails from '@shared/locales/en/provideCommissioningFormDetails.json';
import provideEnergySourcesAndUtilities from '@shared/locales/en/provideEnergySourcesAndUtilities.json';
import provideEnergyUses from '@shared/locales/en/provideEnergyUses.json';
import provideEnvelopeDetailsHEAR from '@shared/locales/en/provideEnvelopeDetailsHEAR.json';
import provideEquipmentInstalledDetails from '@shared/locales/en/provideEquipmentInstalledDetails.json';
import provideEquipmentRemovedDetails from '@shared/locales/en/provideEquipmentRemovedDetails.json';
import provideEvaporativeCoolerInstalledDetails from '@shared/locales/en/provideEvaporativeCoolerInstalledDetails.json';
import provideExistingEquipmentAndSources from '@shared/locales/en/provideExistingEquipmentAndSources.json';
import provideHeatPumpInstalledDetails from '@shared/locales/en/provideHeatPumpInstalledDetails.json';
import provideHeatingEquipmentDetails from '@shared/locales/en/provideHeatingEquipmentDetails.json';
import provideHomeownerDetails from '@shared/locales/en/provideHomeownerDetails.json';
import provideIncomeEnhancedIncentive from '@shared/locales/en/provideIncomeEnhancedIncentive.json';
import provideReservationDetailsCaTechSfv from '@shared/locales/en/provideReservationDetailsCaTechSfv.json';
import provideIncomeEstimate from '@shared/locales/en/provideIncomeEstimate.json';
import provideOtherHomeownerDetails from '@shared/locales/en/provideOtherHomeownerDetails.json';
import provideOtherRebatesDetails from '@shared/locales/en/provideOtherRebatesDetails.json';
import providePreInstallDetails from '@shared/locales/en/providePreInstallDetails.json';
import provideRMIGreenUpdateCalculatorDetails from '@shared/locales/en/provideRMIGreenUpdateCalculatorDetails.json';
import provideScheduledInstallDate from '@shared/locales/en/provideScheduledInstallDate.json';
import provideServices from '@shared/locales/en/provideServices.json';
import provideSiteDetails from '@shared/locales/en/provideSiteDetails.json';
import provideUtilityCredentials from '@shared/locales/en/provideUtilityCredentials.json';
import provideVentilationDetails from '@shared/locales/en/provideVentilationDetails.json';
import provideWaterHeaterInstalledDetails from '@shared/locales/en/provideWaterHeaterInstalledDetails.json';
import provideWxProof from '@shared/locales/en/provideWxProof.json';
import qualityInstallationChecklist from '@shared/locales/en/qualityInstallationChecklist.json';
import reviewCombustionMechanicalForm from '@shared/locales/en/reviewCombustionMechanicalForm.json';
import reviewEnergyUsageDeliveredFuel from '@shared/locales/en/reviewEnergyUsageDeliveredFuel.json';
import reviewFinalInvoice from '@shared/locales/en/reviewFinalInvoice.json';
import reviewIncomeQualification from '@shared/locales/en/reviewIncomeQualification.json';
import reviewInstalledEquipment from '@shared/locales/en/reviewInstalledEquipment.json';
import reviewManualJReport from '@shared/locales/en/reviewManualJReport.json';
import reviewQualityInstallReport from '@shared/locales/en/reviewQualityInstallReport.json';
import reviewScopeOrWork from '@shared/locales/en/reviewScopeOfWork.json';
import reviewSignedTECHCustomerAgreement from '@shared/locales/en/reviewSignedTECHCustomerAgreement.json';
import reviewUtilityBills from '@shared/locales/en/reviewUtilityBills.json';
import sendPayment from '@shared/locales/en/sendPayment.json';
import signApplicationCOXCEL from '@shared/locales/en/signApplicationCOXCEL.json';
import signAvangridAcknowledgementNYCH from '@shared/locales/en/signAvangridAcknowledgementNYCH.json';
import signCentralHudsonAcknowledgementNYCH from '@shared/locales/en/signCentralHudsonAcknowledgementNYCH.json';
import signConEdisonAcknowledgementOwnerNYCH from '@shared/locales/en/signConEdisonAcknowledgementOwnerNYCH.json';
import signConEdisonAcknowledgementRenterNYCH from '@shared/locales/en/signConEdisonAcknowledgementRenterNYCH.json';
import signDecommissioningChecklistNYCH from '@shared/locales/en/signDecommissioningChecklistNYCH.json';
import signFinalinvoiceCO from '@shared/locales/en/signFinalInvoiceCo.json';
import signFinalInvoiceGAHEAR from '@shared/locales/en/signFinalInvoiceGaHear.json';
import signFinalInvoiceWIHEAR from '@shared/locales/en/signFinalInvoiceWIHEAR.json';
import signIRACombustionVentilationFormWIHEAR from '@shared/locales/en/signIRACombustionVentilationFormWIHEAR.json';
import signIraTenantOwnerAcknowledgment from '@shared/locales/en/signIraTenantOwnerAcknowledgment.json';
import signNationalGridAcknowledgementNYCH from '@shared/locales/en/signNationalGridAcknowledgementNYCH.json';
import signORUAcknowledgementNYCH from '@shared/locales/en/signORUAcknowledgementNYCH.json';
import signOfferLetterWIHEAR from '@shared/locales/en/signOfferLetterWIHEAR.json';
import signPreApprovalPacket3CREN from '@shared/locales/en/signPreApprovalPacket3CREN.json';
import signProposedInvoiceWIHEAR from '@shared/locales/en/signProposedInvoiceWIHEAR.json';
import signRebateAssignmentForm from '@shared/locales/en/signRebateAssignmentForm.json';
import signScopeOfWork from '@shared/locales/en/signScopeOfWork.json';
import signSignaturePacketHIASP from '@shared/locales/en/signSignaturePacketHIASP.json';
import signTechCustomerAgreement from '@shared/locales/en/signTechCustomerAgreement.json';
import signUtilityBillImpactCOHEAR from '@shared/locales/en/signUtilityBillImpactCOHEAR.json';
import signUtilityBillImpactWIHEAR from '@shared/locales/en/signUtilityBillImpactWIHEAR.json';
import signup from '@shared/locales/en/signup.json';
import submitEnrollmentFollowUp from '@shared/locales/en/submitEnrollmentFollowUp.json';
import submitFinalDocs from '@shared/locales/en/submitFinalDocs.json';
import submitPreapprovalFollowUp from '@shared/locales/en/submitPreapprovalFollowUp.json';
import submitRebateDetails from '@shared/locales/en/submitRebateDetails.json';
import sunrunDetails from '@shared/locales/en/sunrunDetails.json';
import taskInstructions from '@shared/locales/en/taskInstructions.json';
import unsignedFinalInvoice from '@shared/locales/en/unsignedFinalInvoice.json';
import uploadDecommissioningChecklist from '@shared/locales/en/uploadDecommissioningChecklist.json';
import uploadDemandResponseEvidence from '@shared/locales/en/uploadDemandResponseEvidence.json';
import uploadEquipmentCertificates from '@shared/locales/en/uploadEquipmentCertificates.json';
import uploadFinalInvoice from '@shared/locales/en/uploadFinalInvoice.json';
import uploadFuelSwitchingCalculator from '@shared/locales/en/uploadFuelSwitchingCalculator.json';
import uploadGreenUpdateCalculator from '@shared/locales/en/uploadGreenUpdateCalculator.json';
import uploadManualJReport from '@shared/locales/en/uploadManualJReport.json';
import uploadManualSReport from '@shared/locales/en/uploadManualSReport.json';
import uploadPermit from '@shared/locales/en/uploadPermit.json';
import uploadPhotosOfInstalledMeasures from '@shared/locales/en/uploadPhotosOfInstalledMeasures.json';
import uploadProjectScopeOfWork from '@shared/locales/en/uploadProjectScopeOfWork.json';
import uploadProposedInvoice from '@shared/locales/en/uploadProposedInvoice.json';
import uploadProposedScopeOfWork from '@shared/locales/en/uploadProposedScopeOfWork.json';
import uploadUtilityBills from '@shared/locales/en/uploadUtilityBills.json';
import userPreferences from '@shared/locales/en/userPreferences.json';
import verifyIncomeQualification from '@shared/locales/en/verifyIncomeQualification.json';
import waterHeatingSystem from '@shared/locales/en/waterHeatingSystem.json';
import { createI18n } from 'vue-i18n';

export const sharedEnI18n = {
  ...contractor,
  ...postCASTesting,
  ...reviewCombustionMechanicalForm,
  ...confirmPostInstallDetails,
  ...confirmPostInstallPhotosHeatPump,
  ...confirmPostInstallPhotosGasFurnace,
  ...confirmPostInstallPhotosElectrical,
  ...confirmPostInstallDetailsLoadManagement,
  ...confirmPostInstallDetailsClothesDryer,
  ...confirmPostInstallDetailsInduction,
  ...confirmPostInstallEccCaTechSfv,
  ...confirmPostInstallPhotosVentilation,
  ...confirmPostInstallPhotosWaterHeater,
  ...confirmInstalledHeatPump,
  ...confirmInstalledWaterHeater,
  ...preCASTesting,
  ...preHomeSafetyAssessment,
  ...preLimitedHVACAssessment,
  ...announcements,
  ...provideEnergySourcesAndUtilities,
  ...reviewEnergyUsageDeliveredFuel,
  ...provideServices,
  ...hvacSystem,
  ...jobDetails,
  ...jobsList,
  ...jobCreate,
  ...opportunityAttemptContact,
  ...opportunityFirstContact,
  ...opportunityScheduleAppointment,
  ...opportunityVisitHome,
  ...optionalPreApprovalReservationNyCleanHeatConEd,
  ...provideEnergyUses,
  ...defineScopeOfWork,
  ...confirmPreInstallDetails,
  ...providePreInstallDetails,
  ...provideHomeownerDetails,
  ...sunrunDetails,
  ...provideOtherHomeownerDetails,
  ...provideSiteDetails,
  ...provideEquipmentRemovedDetails,
  ...provideEquipmentInstalledDetails,
  ...provideHeatingEquipmentDetails,
  ...provideExistingEquipmentAndSources,
  ...provideHeatPumpInstalledDetails,
  ...provideWaterHeaterInstalledDetails,
  ...provideIncomeEstimate,
  ...provideReservationDetailsCaTechSfv,
  ...provideIncomeEnhancedIncentive,
  ...verifyIncomeQualification,
  ...signAvangridAcknowledgementNYCH,
  ...signDecommissioningChecklistNYCH,
  ...signORUAcknowledgementNYCH,
  ...signNationalGridAcknowledgementNYCH,
  ...signConEdisonAcknowledgementOwnerNYCH,
  ...signConEdisonAcknowledgementRenterNYCH,
  ...signCentralHudsonAcknowledgementNYCH,
  ...submitRebateDetails,
  ...confirmDecommissioningChecklistData,
  ...confirmInstallDates,
  ...submitEnrollmentFollowUp,
  ...submitPreapprovalFollowUp,
  ...determineShareRebateAmount,
  ...downloadApplicationLadwp,
  ...userPreferences,
  ...companyProfile,
  ...uploadFinalInvoice,
  ...uploadPermit,
  ...provideOtherRebatesDetails,
  ...uploadDemandResponseEvidence,
  ...uploadPhotosOfInstalledMeasures,
  ...uploadProjectScopeOfWork,
  ...uploadProposedScopeOfWork,
  ...submitFinalDocs,
  ...sendPayment,
  ...confirmProjectFinalCosts,
  ...decommissioningChecklistData,
  ...decommissioningChecklistDataCollection,
  ...uploadDecommissioningChecklist,
  ...reviewIncomeQualification,
  ...login,
  ...signup,
  ...error,
  ...energyProviders,
  ...signRebateAssignmentForm,
  ...signIraTenantOwnerAcknowledgment,
  ...signProposedInvoiceWIHEAR,
  ...signUtilityBillImpactWIHEAR,
  ...signUtilityBillImpactCOHEAR,
  ...signTechCustomerAgreement,
  ...signIRACombustionVentilationFormWIHEAR,
  ...signSignaturePacketHIASP,
  ...signPreApprovalPacket3CREN,
  ...signFinalInvoiceWIHEAR,
  ...signFinalInvoiceGAHEAR,
  ...signOfferLetterWIHEAR,
  ...uploadManualJReport,
  ...uploadManualSReport,
  ...provideWxProof,
  ...uploadFuelSwitchingCalculator,
  ...uploadEquipmentCertificates,
  ...uploadGreenUpdateCalculator,
  ...reviewManualJReport,
  ...reviewSignedTECHCustomerAgreement,
  ...provideEnvelopeDetailsHEAR,
  ...provideRMIGreenUpdateCalculatorDetails,
  ...envelopePart,
  ...programSelection,
  ...programPolicies,
  ...programSubmissionsHistory,
  ...uploadUtilityBills,
  ...reviewQualityInstallReport,
  ...reviewUtilityBills,
  ...reviewInstalledEquipment,
  ...provideUtilityCredentials,
  ...provideVentilationDetails,
  ...createScopeOfWork,
  ...commonActions,
  ...commonEquipment,
  ...commonFormValidation,
  ...commonJob,
  ...commonLabels,
  ...commonMessages,
  ...commonPrograms,
  ...commonSignDocument,
  ...commonTasks,
  ...createInitialInvoice,
  ...eligibility,
  ...incentive,
  ...applyForIncomeVerification,
  ...uploadProposedInvoice,
  ...provideAdditionalIncentivesDetails,
  ...combustionSafetyTesting,
  ...mechanicalVentilation,
  ...createOfferLetterDocument,
  ...commonAttachments,
  ...provideScheduledInstallDate,
  ...provideCommissioningFormDetails,
  ...qualityInstallationChecklist,
  ...waterHeatingSystem,
  ...existingElectricalSystem,
  ...proposedElectricalSystem,
  ...confirmPostInstallDetailsHeatPump,
  ...confirmPostInstallDetailsWaterHeater,
  ...confirmPostInstallDetailsHeating,
  ...confirmPostInstallDetailsVentilation,
  ...signApplicationCOXCEL,
  ...enrollInRequiredInitiatives,
  ...signScopeOfWork,
  ...commonUser,
  ...constraint,
  ...existingWeatherizationDetails,
  ...proposedWeatherizationDetails,
  ...signFinalinvoiceCO,
  ...initiateIncomeQualificaiton,
  ...taskInstructions,
  ...reviewScopeOrWork,
  ...reviewFinalInvoice,
  ...unsignedFinalInvoice,
  ...provideEvaporativeCoolerInstalledDetails,
  ...confirmPostInstallDetailsEvaporativeCooler
};

export type LocaleMessages = Record<string, unknown>;
export type LocaleModule = { default: LocaleMessages };

// Fetches every lazily-globbed JSON file in a locale directory and merges them
// into one message tree.
export const loadLocaleModules = async (
  loaders: Record<string, () => Promise<LocaleModule>>
) => {
  const modules = await Promise.all(
    Object.values(loaders).map((load) => load())
  );
  return modules.reduce<LocaleMessages>(
    (messages, module) => ({ ...messages, ...module.default }),
    {}
  );
};

// Spanish files are picked up automatically; each one must mirror its English
// counterpart key-for-key (enforced by `just i18n-check`). They're split into
// their own chunk and only fetched once a user switches to Spanish.
export const loadSharedEsMessages = () =>
  loadLocaleModules(import.meta.glob<LocaleModule>('./locales/es/*.json'));

export const SUPPORTED_LOCALES = ['en', 'es'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

// Message loaders for every non-default locale; English is always bundled.
export type LocaleMessageLoaders = Record<
  Exclude<SupportedLocale, 'en'>,
  () => Promise<LocaleMessages>
>;

export const localeForLanguage = (
  language?: PreferredLanguage | null
): SupportedLocale => (language === PreferredLanguage.SPANISH ? 'es' : 'en');

export default createI18n({
  legacy: false,
  locale: 'en', // default language
  fallbackLocale: 'en', // fallback language in case a translation is not found
  messages: {
    en: {
      sharedEnI18n
    }
  }
});
